import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/* CSS */
import '../../../styles/stepper.css'

/* HOOKS */
import useInsert from '../../../hooks/useInsert';
import Page1 from './addwizard/page1';
import Page2 from './addwizard/page2';
import ImageCapture from '../../../components/ImageCapture';
import Stepper from './addwizard/stepper';
import Page4 from './addwizard/page4';
import Page5 from './addwizard/page5';
import Page3 from './addwizard/page3';
import Swal from 'sweetalert2';
import useSendEmail from "../../../hooks/useSendEmail";
import useUpdate from "../../../hooks/useUpdate";


/* COMPONENTS */


/* USER */
import { useAuth } from '../../../contexts/AuthContext';
import BackdropModal from '../../../components/modals/backdrop_modal';
import NotaryAcknowledgment from './addwizard/NotaryAcknowledgment';


/* PRINT */
import { printContent } from '../../../utils/printUtils';
// import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import LoadingAnimation from '../../../components/Loading';

import html2pdf from 'html2pdf.js';


 

// Main Wizard Form Component
function TechOathAmplifyAddWizard() {

  const gotoPage=(page)=>{
    navigate(page);
  }


  const printableAcknowledgement = useRef(null);
  
  const printAcknowledgementPage = () => {
    if (printableAcknowledgement.current) {
      const divContents = printableAcknowledgement.current.innerHTML;
      const additionalStyles = `
        .bt_bp {
          border-top: 1px solid #28a745;
        }

        .text-times-new-roman {
          font-family: 'Times New Roman', Times, serif;
        }
      `;
      printContent(divContents, additionalStyles);
    } else {
      console.error("Ref is null, cannot access innerHTML");
    }
  };

//   const handleDownloadPDF = () => {
//     const element = printableAcknowledgement.current;
//     html2pdf(element, {
//       filename: 'my-document.pdf',
//       margin: 1,
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
//     });
// };

  

 

  const navigate = useNavigate();
  const { user } = useAuth();
  const lawyerId = user.user_id;
  const lawyerProfilePhoto = user.user_profile_photo

  const [loadingText,setLoadingText] = useState("Loading...");



  const [currentPage, setCurrentPage] = useState(1);
  const nextPage = () => setCurrentPage(currentPage + 1);
  const prevPage = () => setCurrentPage(currentPage - 1);
  const getTitleClass = (page) => (currentPage === page ? 'active' : '');

  const [showAcknowledgement,setShowAcknowledgement] = useState(false)


  const [formData, setFormData] = useState({
 
    // PAGE 1
    documentName : '',
    documentTitle: '',
    documentNo   : '',
    pageNo       : '',
    bookNo       : '',

    requestFor:'self',
    relationshipToBeneficiary:'',

    insidePhilippines:'',
    question1:'',
    question2:'',
    question3:'',
    question4:'',

    // PAGE 2
    idType:'',
    idNo:'',
    dateIssued:'',
    governmentId:'',
    scannedImages:[],
    signature:'',


    // PAGE3
    firstName:'',
    middleName:'',
    lastName:'',
    birthday:null,
    gender:'',
    country:'Philippines',
    region:'',
    province:'',
    cityMunicipality:'',
    barangay:'',
    contactNumber:'',
    email:'',

    // PAGE4
    amount:'',
    referenceNo:'',
    datePaid:'',
    paymentMethod:'CASH',
    description:'',

    transaction_status:'PENDING',

    // PAGE 5
    lawyerImage:lawyerProfilePhoto,
    isLawyerImageIsLink:true,
  });
  

/* HOOKS USAGE */
const { insertData, isLoading, errorMessage, successMessage, responseData } = useInsert();
const { sendEmail, responseEmail, errorEmail } = useSendEmail();
const { updateData, isLoading:isLoadingUpdate, errorMessage:errorMessageUpdate, successMessage:successMessageUpdate, responseData:responseDataUpdate } = useUpdate('patch');



const [isSubmitting, setIsSubmitting] = useState(false);
const [successStatus, setSuccessStatus] = useState("")

 
const [endTransaction, setEndTransaction] = useState(false);

 

const sendToEmail = async () => {
  setIsSubmitting(true);
  try {
    const element = printableAcknowledgement.current;

    // Configure html2pdf options
    const options = {
      margin:       0,
      filename:     `${transactionId}.pdf`,
      image:        { type: 'png', quality: 1 },
      html2canvas:  { scale: 2 },
      // jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
      jsPDF:        { unit: 'mm', format: [210, 320], orientation: 'portrait' } // Custom size: [width, height] in mm
    };

    // Generate PDF using html2pdf.js
    html2pdf()
      .from(element) // From the printable element
      .set(options)  // Set options
      .toPdf()
      .get('pdf')
      .then(function(pdf) {
        // Convert the PDF to a Blob
        const pdfBlob = pdf.output('blob');

        // Create a FormData object to send via API
        const formDataEmail = new FormData();
        formDataEmail.append('pdf', pdfBlob, `${transactionId}.pdf`);
        formDataEmail.append('document_id', transactionId);
        formDataEmail.append('released_by_id', lawyerId);
        formDataEmail.append('recipient_email', formData.email);

        // Send the PDF to the server via the API
        const url = `${process.env.REACT_APP_API_URL}/transactions/upload_pdf/`;
        
          updateData(url, formDataEmail, (responseData) => {
          if (responseData) {
            setSuccessStatus(responseData.status);
            setIsSubmitting(false);
            setEndTransaction(true);
          }
        });
      });

  } catch (error) {
    console.error('Error generating or uploading PDF:', error);
  }
};


/*
const sendToEmail = async () => {
  setIsSubmitting(true);
  try {
    const canvas = await html2canvas(printableAcknowledgement.current);
    const imgData = canvas.toDataURL('image/png');

    // Create a new jsPDF instance
    const pdf = new jsPDF();
    pdf.setFillColor(null);
    pdf.addImage(imgData, 'PNG', 10, 10, 190, 0); // Adjust the position and size as needed

    // Convert the PDF to a Blob
    const pdfBlob = pdf.output('blob');

    // Create a FormData object
    const formDataEmail = new FormData();
    formDataEmail.append('pdf', pdfBlob, `${transactionId}.pdf`);
    formDataEmail.append('document_id', transactionId); // Replace with the actual document ID
    formDataEmail.append('released_by_id', lawyerId);
    formDataEmail.append('recipient_email', formData.email);
    try {
      const url = `${process.env.REACT_APP_API_URL}/transactions/upload_pdf/`
      await updateData(url, formDataEmail, (responseData) => {
        if (responseData) {
          setSuccessStatus(responseData.status)
        }
      });
    } catch (error) {
      console.error('Update failed:', error);
    }
  } catch (error) {
    console.error('Error generating or uploading PDF:', error);
  }
  finally {
    setIsSubmitting(false);
  }
};
*/

const [qr,setQR] = useState("");
const [transactionId,setTransactionId] = useState("");
const [releasedDate,setReleasedDate] = useState("");


const [isFromURL,setIsfromUrl] = useState("no");
    useEffect(() => {
      
        if (typeof formData.lawyerImage === "string") {
            setIsfromUrl("yes");
        } else if (formData.lawyerImage instanceof File) {
            setIsfromUrl("no");
        }
        else{
          setIsfromUrl("yes");
        }
      
    }, [formData.lawyerImage]);

   

  const saveData = async() => {
    

    console.log(formData.scannedImages);
 

        const result = await Swal.fire({
            title             : 'Save information ?',
            // text              : 'Do you want to proceed ?',
            icon              : 'warning',
            showCancelButton  : true,
            confirmButtonColor: 'btn-info',
            cancelButtonColor : 'btn-secondary',
            confirmButtonText : 'Yes, save!',
            cancelButtonText  : 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
        });



        


        const formattedDateBirthday = formData.birthday.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Manila'
        });

       const formattedDatePaid = formData.datePaid ? new Date(formData.datePaid).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';



       const formattedDateIssued = formData.dateIssued ? new Date(formData.dateIssued).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';


       const secondPartyFormattedDateIssued = formData.secondPartyDateIssued ? new Date(formData.secondPartyDateIssued).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';


       const secondPartyFormattedDateBirthday = formData.secondPartyBirthday ? new Date(formData.secondPartyBirthday).toLocaleDateString('en-CA', { timeZone: 'Asia/Manila', }) : '';

 
     

        const finalFormData = {


          // PAGE 1
            document_name : formData.documentName,
            document_title: formData.documentTitle,
            document_no   : formData.documentNo,
            page_no       : formData.pageNo,
            book_no       : formData.bookNo,


            relationship         : formData.relationshipToBeneficiary,
            document_for_whom    : formData.requestFor,
             
            is_inside_philippines: formData.insidePhilippines,
            question_1           : formData.question1,
            question_2           : formData.question2,
            question_3           : formData.question3,
            question_4           : formData.question4,


          // PAGE 2
            // (GOVERNMENT ID)
            attachment_image         : formData.governmentId,
            attachment_id_file       : formData.governmentId.name,
            attachment_id_type       : formData.idType,
            attachment_id_number     : formData.idNo,
            attachment_id_date_issued: formattedDateIssued,


            // (GOVERNMENT ID SECOND PARTY)
            second_party_attachment_image         : formData.secondPartyGovernmentId,
            second_party_attachment_id_file       : formData.secondPartyGovernmentId?.name ?? "",
            second_party_attachment_id_type       : formData.secondPartyIdType,
            second_party_attachment_id_number     : formData.secondPartyIdNo,
            second_party_attachment_id_date_issued: secondPartyFormattedDateIssued,
 

            // (SCANNED DOCUMENTS)
            scanned_image : formData.scannedImages,
            

            // (SIGNATURE)
            signature_image : formData.principalImageSignature,
            second_party_signature_image : formData.secondPartyPrincipalImageSignature,
           
            // PRINCIPAL
            principal_image_file: formData.principalImage,
            second_party_principal_image_file: formData.secondPartyPrincipalImage,



            // WITNESSES
            witness_1_fullname : formData.witnessFirstFullname,
            witness_1_image    : formData.witnessFirstPhoto,
            witness_1_signature: formData.witnessFirstPhotoSignature,
            witness_2_fullname : formData.witnessSecondFullname,
            witness_2_image    : formData.witnessSecondPhoto,
            witness_2_signature: formData.witnessSecondPhotoSignature,



          // PAGE 3
            first_name               : formData.firstName,
            middle_name              : formData.middleName,
            last_name                : formData.lastName,
            suffix                   : formData.suffix,
            birth_date               : formattedDateBirthday,
            gender                   : formData.gender,
            contact_number           : formData.contactNumber,
            email                    : formData.email,


            // 2nd Party
            second_party_first_name               : formData.secondPartyFirstName,
            second_party_middle_name              : formData.secondPartyMiddleName,
            second_party_last_name                : formData.secondPartyLastName,
            second_party_suffix                   : formData.secondPartySuffix,
            second_party_birth_date               : secondPartyFormattedDateBirthday,
            second_party_gender                   : formData.secondPartyGender,
            second_party_contact_number           : formData.secondPartyContactNumber,
            second_party_email                    : formData.secondPartyEmail,






            country                  : formData.country,
            region                   : formData.region,
            province                 : formData.province,
            city                     : formData.cityMunicipality,
            barangay                 : formData.barangay,
            residence                : formData.cityMunicipality,


            // PAGE 4
            reference_no      : formData.referenceNo,
            status_description: formData.description,
            payment_amount    : formData.amount,
            date_paid         : formattedDatePaid,
            payment_method    : formData.paymentMethod,

            // PAGE 5
            lawyer_profile_photo : formData.lawyerImage,
            lawyer_profile_photo_is_link : isFromURL,
            lawyer_profile_photo_link : lawyerProfilePhoto,





          // THIS IS REQUIRED FIELDS
          transaction_status        : 'PENDING',
          meeting_id                : '',
          meeting_pass              : '',
          transaction_payment_status: 'PAID',
          document_price            : formData.amount,
          document_attachment       : '',
          user_location             : formData.region,
          document_to_address       : `${formData.region}, ${formData.province}, ${formData.cityMunicipality}, ${formData.barangay}`,
          created_by                : lawyerId,
          updated_by                : lawyerId,
          is_save                   : 1,
          user_profile              : lawyerId,
       

          // THIS ISNT REQUIRED FIELDS
          transaction_type         : "WALK-IN",
          for_draft                : 0,
          administrative_officer_id: lawyerId,
          released_by_id           : lawyerId,
      };
        
      console.log(formData);
      console.log("finalFormData",finalFormData);
  
        if (result.isConfirmed) {
            setLoadingText("Saving application & Uploading Documents...");
            try {
               await insertData(`${process.env.REACT_APP_API_URL}/transactions/`, finalFormData, (responseData) => {
                    // navigate('/certificates/');
                  if(responseData.message==="success"){
                      setQR(responseData.qr);
                      setTransactionId(responseData.transaction_id);
                      setReleasedDate(responseData.date_released);
                      setShowAcknowledgement(true);
                      setShowSaveButton(false);
                   }
               });
             

              } catch (error) {
                console.error("Error inserting data:", error);
              }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Submission cancelled.');
          }

  };

  const [showSaveButton,setShowSaveButton] = useState(true);

  const closeModal = () => {
    setShowAcknowledgement(false);
  };

  
 

  return (
      <div className="container-xxl flex-grow-1 container-p-y">
        <h4 className="py-3 mb-4">
          <span className="text-muted fw-light">Transaction /</span>
          <span>Add</span>
        </h4>

        {isLoading && <LoadingAnimation text={loadingText} />}
        {errorMessage && (
          <div className="alert alert-danger">
              {typeof errorMessage === 'object'
                  ? Object.entries(errorMessage).map(([field, messages]) => (
                      <div key={field}>
                          <strong>{field.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong>{messages.join(', ')}
                      </div>
                    ))
                  : String(errorMessage)}
          </div>
      )}

        {successMessage && <div className="success">{successMessage}</div>}

        <div id="wizard-validation" className="bs-stepper mt-2 linear">
          
          <Stepper getTitleClass={getTitleClass} />

          <div className="bs-stepper-content">
            {/* <button type='button' onClick={()=>setShowAcknowledgement(true)} >Open </button> */}

            {currentPage === 1 && (
              <Page1
                formData={formData}
                setFormData={setFormData}
                nextPage={nextPage}
              />
            )}
            {currentPage === 2 && (
              <Page2
                formData={formData}
                setFormData={setFormData}
                nextPage={nextPage}
                prevPage={prevPage}
              />
            )}
            {currentPage === 3 && (
              <Page3
                formData={formData}
                setFormData={setFormData}
                nextPage={nextPage}
                prevPage={prevPage}
              />
            )}

            {currentPage === 4 && (
              <Page4
                formData={formData}
                setFormData={setFormData}
                nextPage={nextPage}
                prevPage={prevPage}
              />
            )}

            {currentPage === 5 && (
              <Page5
                formData={formData}
                setFormData={setFormData}
                prevPage={prevPage}
                saveData={saveData}
                showSaveButton={showSaveButton}
              />
            )}


          </div>
        </div>

        <BackdropModal  size={"md"} open={showAcknowledgement} handleClose={closeModal} modalTitle="Notarial Acknowledgement">
          <div ref={printableAcknowledgement}>
            <NotaryAcknowledgment formData={formData} qr={qr} transactionId={transactionId} dateReleased={ releasedDate ? releasedDate : new Date()} />
          </div>
          <div className="mt-3 ms-4">
              <button type='button' className="btn btn-primary me-2" onClick={printAcknowledgementPage}>Print Document</button>
              {endTransaction && 
               <button className="btn btn-primary me-2" type="button"   onClick={sendToEmail}>
                {isSubmitting ?
                  <><span className="spinner-grow me-1" role="status" aria-hidden="true"></span>Generating PDF and Sending to email, Please wait and do not close...</>
                  :
                  <><span  className="" role="status" aria-hidden="true"></span>Send To Email and Release</>
                }
              </button>
              }
             

{endTransaction && <button type='button' className="btn btn-primary me-2" onClick={()=>gotoPage('/oath/')}>End Transaction</button>}


              {/* <button type='button' className="btn btn-success" onClick={handleDownloadPDF}>Download PDF</button> */}
          </div>
        </BackdropModal>
      </div>
  );
}

export default TechOathAmplifyAddWizard;
